var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 10.6992C0.664062 5.17637 5.14121 0.699219 10.6641 0.699219H38.6641C44.1869 0.699219 48.6641 5.17637 48.6641 10.6992V38.6992C48.6641 44.2221 44.1869 48.6992 38.6641 48.6992H10.6641C5.14121 48.6992 0.664062 44.2221 0.664062 38.6992V10.6992Z",
    fill: "url(#paint0_linear_4168_5896)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6641 24.6992H32.1841C31.747 24.6983 31.3217 24.8405 30.9732 25.1042C30.6246 25.3678 30.3721 25.7384 30.2541 26.1592L27.9041 34.5192C27.8889 34.5711 27.8573 34.6168 27.8141 34.6492C27.7708 34.6817 27.7182 34.6992 27.6641 34.6992C27.61 34.6992 27.5573 34.6817 27.5141 34.6492C27.4708 34.6168 27.4392 34.5711 27.4241 34.5192L21.9041 14.8792C21.8889 14.8273 21.8573 14.7817 21.8141 14.7492C21.7708 14.7168 21.7182 14.6992 21.6641 14.6992C21.61 14.6992 21.5573 14.7168 21.5141 14.7492C21.4708 14.7817 21.4392 14.8273 21.4241 14.8792L19.0741 23.2392C18.9565 23.6584 18.7054 24.0277 18.3589 24.2912C18.0124 24.5547 17.5894 24.698 17.1541 24.6992H14.6641",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5896",
    x1: 24.6641,
    y1: 0.699219,
    x2: 24.6641,
    y2: 48.6992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcura);
export default __webpack_public_path__ + "static/media/mcura.a612e77ec5857d0b86500d4a52f2bc94.svg";
export { ForwardRef as ReactComponent };